import { PHONE_NUMBERS } from './phone-numbers';

export const ERROR_TYPES = {
  INVALID_CARD: 'invalid_card',
  INVALID_PHONE_EMAIL: 'invalid_phone_email',
  INVALID_PHONE: 'invalid_phone',
  INVALID_EMAIL: 'invalid_email',
  UNKNOWN: 'unknown',
};

export const ERROR_MESSAGES = {
  INVALID_CARD: 'Your card is declined or invalid. Please try again.',
  INVALID_PHONE: 'Please enter valid phone number',
  INVALID_EMAIL: 'Please enter valid email address',
  FIELDS_MISSING_INCORRECT: 'Some fields are missing or incorrect.',
  EXPERIENCING_ISSUE: `We're experiencing an issue, please try again later or give us a call, ${PHONE_NUMBERS.CUSTOMER_SERVICE}.`,
};
